import { useEffect, useEffectEvent } from 'react'
import { useSelector } from '@/libs/state'
import { session$ } from '@/features/auth/store'
import { notificationsAdapter } from '../store'
import { notificationsFeed } from '../wiring'

const useInitNotifications = () => {
	const userId = useSelector(() => session$.user?.get()?.id ?? null)

	const startFeed = useEffectEvent(async (id: string) => {
		return notificationsFeed.subscribe(id, notification => {
			notificationsAdapter.push(notification)
		})
	})

	useEffect(() => {
		if (!userId) {
			notificationsAdapter.clear()
			return
		}

		let cleanup: (() => void) | undefined

		startFeed(userId).then(unsubscribe => {
			cleanup = unsubscribe
		})

		return () => {
			cleanup?.()
		}
	}, [userId])
}

export { useInitNotifications }
